import { render, staticRenderFns } from "./ContentEditablePlayer.vue?vue&type=template&id=3fdbf55a&"
import script from "./ContentEditablePlayer.vue?vue&type=script&lang=js&"
export * from "./ContentEditablePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports